import React from 'react'

import { YStack, styled, useThemeName } from 'tamagui'

import BackgroundGradientPath from './BackgroundGradient.svg'
import BackgroundGradientDarkPath from '../../assets/background-gradient-dark.svg'

import { HERO_BACKGROUND_IMAGE_URL } from '../data/config/images'

export const Screen = styled(YStack, {
  name: 'Screen',

  marginTop: 0,
  marginLeft: 'auto',
  marginRight: 'auto',

  paddingTop: 24 * 4,
  // paddingHorizontal: 5 * 4,

  width: '100%',
  maxWidth: '100%',
  flexGrow: 1,

  $gtXs: {
    paddingHorizontal: 8 * 4,
  },

  $gtSm: {
    // @ts-expect-error style is valid for web CSS
    style: {
      paddingLeft: `calc(env(safe-area-inset-left, 10px) + 32px)`,
      paddingRight: `calc(env(safe-area-inset-right, 10px) + 32px)`,
    },
  },

  $gtLg: {
    maxWidth: 1200,
  },

  // @ts-ignore style is valid for web CSS
  style: {
    paddingLeft: `calc(env(safe-area-inset-left, 10px) + 20px)`,
    paddingRight: `calc(env(safe-area-inset-right, 10px) + 20px)`,
    paddingBottom: `calc(env(safe-area-inset-bottom, 0px) + 20px)`,
  },
} as const)

const GradientBackgroundScreenBase = styled(YStack, {
  name: 'Screen',

  marginTop: 0,
  marginLeft: 'auto',
  marginRight: 'auto',

  paddingTop: 24 * 4,

  width: '100%',
  maxWidth: '100%',
  flexGrow: 1,

  $gtXs: {
    paddingHorizontal: 8 * 4,
  },

  $gtSm: {
    // @ts-ignore style is valid for web CSS
    style: {
      paddingLeft: `calc(env(safe-area-inset-left, 10px) + 32px)`,
      paddingRight: `calc(env(safe-area-inset-right, 10px) + 32px)`,
    },
  },
} as const)

export const GradientBackgroundScreen = React.forwardRef<
  React.ElementRef<typeof GradientBackgroundScreenBase>,
  React.ComponentPropsWithoutRef<typeof GradientBackgroundScreenBase>
>(({ style, ...props }, ref) => {
  const themeName = useThemeName()
  const bgPath = themeName === 'dark' ? BackgroundGradientDarkPath : BackgroundGradientPath

  return (
    <GradientBackgroundScreenBase
      ref={ref}
      {...props}
      // @ts-ignore style is valid for web CSS
      style={{
        paddingLeft: `calc(env(safe-area-inset-left, 10px) + 20px)`,
        paddingRight: `calc(env(safe-area-inset-right, 10px) + 20px)`,
        paddingBottom: `calc(env(safe-area-inset-bottom, 0px) + 20px)`,
        backgroundImage: `linear-gradient(to bottom, transparent 50%, var(--background) 100%), url('${bgPath}')`,
        backgroundPosition: 'top, top',
        backgroundRepeat: 'no-repeat, no-repeat',
        backgroundSize: '100% auto, 100% auto',
        ...(typeof style === 'object' ? style : {}),
      }}
    />
  )
})
